import { ChangeDetectionStrategy, Component, effect, Inject, input, signal } from "@angular/core";
import { formatPrice } from "@zaeper/angular-dashboard-view-lib";
import { ZDictionaryPipe } from "@zaeper/angular-localization-lib";
import { IDeveloperBillingRestClient } from "../../rest-clients/billing/i-developer-billing-rest.client";
import { developerBillingRestClientInjectionToken } from "../../rest-clients/billing/developer-billing-rest-client-injection-token";

/**
 * The developer licence's yearly price from Stripe: in the customer's currency, or before a customer exists in the
 * currency of `country`.
 */
@Component({
  selector: "app-licence-price",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ ZDictionaryPipe ],
  template: `
    @if (price(); as text) {
      <span class="text-sm text-surface-600 dark:text-surface-300">{{ "licence-price-per-year" | zDictionary: "main" : text }}</span>
    }
  `
})
export class LicencePriceComponent {
  public readonly country = input<string | null>( null );
  public readonly price = signal<string | null>( null );

  constructor(
    @Inject(developerBillingRestClientInjectionToken) private readonly _billingRestClient: IDeveloperBillingRestClient
  ) {
    effect( () => {
      const country = this.country();
      this._billingRestClient.getLicensePrice( country ).then( prices => {
        const yearly = prices.find( p => p.interval === "YEARLY" );
        this.price.set( yearly ? formatPrice( yearly.unitAmount, yearly.currency ) : null );
      } ).catch( () => this.price.set( null ) );
    } );
  }
}
